import { render, staticRenderFns } from "./warranty.vue?vue&type=template&id=58cc335c&scoped=true&"
import script from "./warranty.vue?vue&type=script&lang=js&"
export * from "./warranty.vue?vue&type=script&lang=js&"
import style0 from "./warranty.vue?vue&type=style&index=0&id=58cc335c&lang=scss&scoped=true&"
import style1 from "./warranty.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc335c",
  null
  
)

export default component.exports